import React from 'react';
import { Button } from '@neshane/blueberry';
import Modal from './Modal';
import './ConfirmModal.css';

function ConfirmModal({
    isOpen,
    onClose,
    onConfirm,
    title = 'تایید عملیات',
    message,
    confirmText = 'تایید',
    cancelText = 'انصراف',
    type = 'danger'
}) {
    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    const confirmVariant = type === 'danger' ? 'primaryAlert' : 'primaryBrand';

    const footer = (
        <>
<Button
                variant="secondaryNeutral"
                text={cancelText}
                onClick={onClose}
            />
            <Button
                variant={confirmVariant}
                text={confirmText}
                onClick={handleConfirm}
            />
        </>
    );

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            footer={footer}
            size="small"
            iconName={type === 'danger' ? 'triangle-warning' : 'circle-check'}
        >
            <p className="confirm-message">{message}</p>
        </Modal>
    );
}

export default ConfirmModal;